import React, { useCallback, useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useRowConfig } from '../../../../../hooks';
import { useInventoryPermissions } from '../../../../../hooks/useInventoryPermissions';
import { getAutoInventoryBadge } from '../../../../../utils/badges';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { RowBase } from '../../../../Table/RowBase/RowBase';
import type { InventoryValue } from '../../../inventoryStatusUtils';

const RoomPriceRowComponent: React.FC<{ roomId: number }> = ({ roomId }) => {
  const { inventoryRooms, formatter, onDuplicate } = useRowConfig({
    entityId: roomId,
    entityType: InventoryTabItemName.Rooms,
    fieldName: 'price',
    formatterName: 'price',
  });
  const { canEditPrice } = useInventoryPermissions();
  const { hotelInfo } = useContext(HotelContext);
  const { roomsList } = useContext(ModernHotelContext);
  const room = roomsList.find((r) => r.id === roomId);

  const handleGetBadge = useCallback(
    (values: InventoryValue) => {
      const roomValues = values as RoomOpeningInventory;

      return getAutoInventoryBadge({
        stockScrapperEnabled: hotelInfo?.stockScrapperEnabled ?? false,
        bookingcomId: room?.bookingcomId,
        isAutomated: roomValues.isPriceAutomated,
        value: roomValues.price,
      });
    },
    [hotelInfo?.stockScrapperEnabled, room?.bookingcomId]
  );

  if (!inventoryRooms) {
    return null;
  }

  return (
    <RowBase
      label="BAR RO (NA/NR)"
      entityId={roomId}
      fieldName="price"
      entityType={InventoryTabItemName.Rooms}
      formatter={formatter}
      onDuplicate={onDuplicate}
      isEditable={canEditPrice}
      getBadge={handleGetBadge}
    />
  );
};

export const RoomPriceRow = React.memo(RoomPriceRowComponent);
